import ModalController from "@script/controllers/modal_controller";

export default class QrcodeController extends ModalController {
  connect(){
    super.connect();

    this.open();
  }
}
